<template>
  <div class="login-page">
    <div class="login-orb login-orb--one"></div>
    <div class="login-orb login-orb--two"></div>
    <div class="login-orb login-orb--three"></div>

    <div
      class="login-card animate__animated animate__fadeInUp"
      :class="device.desktop ? `` : `login-card--mobile`"
    >
      <!-- Panel kiri: branding -->
      <div
        v-show="device.desktop"
        class="login-brand"
      >
        <div class="login-brand-content">
          <img
            src="/images/logo-kab.png"
            width="110"
            alt="Logo Kabupaten Tangerang"
            class="login-brand-logo animate__animated animate__fadeInDown"
          />
          <div class="login-brand-title">
            PEMERINTAH<br />KABUPATEN TANGERANG
          </div>
          <div class="login-brand-divider"></div>
          <div class="login-brand-subtitle">
            Aplikasi Pemantauan CCTV<br />Kabupaten Tangerang
          </div>
          <div class="login-brand-badge">
            <v-icon
              small
              color="#93c5fd"
            >mdi-cctv</v-icon>
            <span>Live Monitoring 24/7</span>
          </div>
        </div>
      </div>

      <!-- Panel kanan: form login -->
      <div class="login-form">
        <div
          v-show="device.mobile"
          class="login-form-logo"
        >
          <img
            src="/images/logo-kab.png"
            width="72"
            alt="Logo Kabupaten Tangerang"
          />
        </div>

        <div class="login-form-title">Selamat Datang</div>
        <div class="login-form-subtitle">
          Masuk dengan akun anda untuk melanjutkan
        </div>

        <div class="login-form-fields">
          <div class="login-field-label">Pengguna</div>
          <v-text-field
            v-model="uname"
            solo
            flat
            dense
            hide-details
            background-color="#f1f5f9"
            placeholder="Masukan nama pengguna"
            prepend-inner-icon="mdi-account-outline"
            class="login-field"
            color="#1d4ed8"
          ></v-text-field>

          <div class="login-field-label mt-4">Kata Sandi</div>
          <v-text-field
            v-model="upass"
            solo
            flat
            dense
            hide-details
            background-color="#f1f5f9"
            placeholder="Masukan kata sandi"
            prepend-inner-icon="mdi-lock-outline"
            :append-icon="showPass ? `mdi-eye-off-outline` : `mdi-eye-outline`"
            :type="showPass ? `text` : `password`"
            class="login-field"
            color="#1d4ed8"
            @click:append="showPass = !showPass"
            v-on:keyup.enter="postAuthent"
          ></v-text-field>

          <v-btn
            block
            large
            depressed
            dark
            :loading="loading"
            class="login-btn mt-7"
            @click="postAuthent"
          >
            <v-icon
              left
              small
            >mdi-login-variant</v-icon>
            Masuk
          </v-btn>

          <div class="login-form-footer">
            <v-icon
              x-small
              color="#94a3b8"
            >mdi-shield-check-outline</v-icon>
            <span>Akses aman &amp; terenkripsi</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import "animate.css";
export default {
  name: "LoginComponent",
  data: () => ({
    uname: "",
    upass: "",
    showPass: false,
    loading: false,
  }),
  mounted() {
    this.setPage({
      crud: false,
      page: "login",
    });
  },
  computed: {
    ...mapState(["device", "theme", "info", "http", "snackbar", "auth"]),
  },
  methods: {
    ...mapActions(["setPage", "signIn"]),
    postAuthent: function () {
      this.loading = true;
      this.signIn({
        username: this.uname.replace(/ /g, ""),
        userpass: this.upass,
      }).then((pass) => {
        this.loading = false;
        if (!pass) {
          console.clear();
          return;
        }
        try {
          if (this.auth.user.user.authent == "superadmin") {
            this.$router.push({ name: "dashboard" });
          }
          if (this.auth.user.user.authent == "administrator") {
            this.$router.push({ name: "dashboard" });
          }
          if (this.auth.user.user.authent == "operator") {
            this.$router.push({ name: "dashboard" });
          }
          if (this.auth.user.user.authent == "opd") {
            this.$router.push({ name: "dashboard" });
          }
          if (this.auth.user.user.authent == "user") {
            this.$router.push({ name: "dashboard" });
          }
          if (this.auth.user.user.authent == "perusahaan") {
            this.$router.push({ name: "perusahaan-dashboard" });
          }
        } catch (error) {
          this.snackbar.color = "red";
          this.snackbar.text = error;
          this.snackbar.state = true;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background: #0f172a;
  overflow: hidden;
}

/* Ilustrasi CCTV / kota malam, selaras tema dashboard */
.login-page::before {
  content: "";
  position: absolute;
  inset: -40px;
  background: url("/images/bg-login-cctv.png?v=2") center / cover no-repeat;
  animation: city-zoom 30s ease-in-out infinite alternate;
}

/* Overlay navy tipis agar kartu login tetap kontras */
.login-page::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(10, 18, 36, 0.62) 0%,
    rgba(11, 58, 121, 0.28) 55%,
    rgba(15, 23, 42, 0.45) 100%
  );
}

@keyframes city-zoom {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.12);
  }
}

/* Dekorasi lingkaran blur di background */
.login-orb {
  position: absolute;
  z-index: 0;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.35;
  pointer-events: none;
}

.login-orb--one {
  width: 380px;
  height: 380px;
  background: #3b82f6;
  top: -120px;
  right: -80px;
}

.login-orb--two {
  width: 300px;
  height: 300px;
  background: #1e40af;
  bottom: -100px;
  left: -60px;
}

.login-orb--three {
  width: 200px;
  height: 200px;
  background: #60a5fa;
  top: 40%;
  left: 30%;
  opacity: 0.25;
}

/* Kartu utama */
.login-card {
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  max-width: 880px;
  min-height: 520px;
  border-radius: 24px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 24px 64px rgba(2, 6, 23, 0.45);
}

.login-card--mobile {
  min-height: unset;
  max-width: 440px;
}

/* Panel branding kiri */
.login-brand {
  flex: 1 1 45%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
  background: linear-gradient(160deg, #0f172a 0%, #0b3a79 60%, #1e40af 100%);
  position: relative;
}

.login-brand::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 80% 20%,
    rgba(96, 165, 250, 0.25),
    transparent 55%
  );
}

.login-brand-content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.login-brand-logo {
  filter: drop-shadow(0 8px 24px rgba(0, 0, 0, 0.4));
}

.login-brand-title {
  margin-top: 24px;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #ffffff;
  line-height: 1.4;
}

.login-brand-divider {
  width: 48px;
  height: 3px;
  border-radius: 3px;
  background: #60a5fa;
  margin: 16px auto;
}

.login-brand-subtitle {
  font-size: 13px;
  font-weight: 500;
  color: #bfdbfe;
  line-height: 1.6;
}

.login-brand-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 28px;
  padding: 6px 16px;
  border-radius: 999px;
  border: 1px solid rgba(147, 197, 253, 0.4);
  background: rgba(255, 255, 255, 0.06);
  font-size: 12px;
  font-weight: 600;
  color: #bfdbfe;
}

/* Panel form kanan */
.login-form {
  flex: 1 1 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 44px;
}

.login-card--mobile .login-form {
  padding: 36px 28px;
}

.login-form-logo {
  text-align: center;
  margin-bottom: 16px;
}

.login-form-title {
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
  text-align: center;
}

.login-form-subtitle {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 400;
  color: #64748b;
  text-align: center;
}

.login-form-fields {
  margin-top: 32px;
}

.login-field-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #475569;
  margin-bottom: 6px;
}

.login-field >>> .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.login-field.v-input--is-focused >>> .v-input__slot {
  border-color: #1d4ed8;
  box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.12);
}

.login-btn {
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  font-size: 13px;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%) !important;
  box-shadow: 0 10px 24px rgba(29, 78, 216, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(29, 78, 216, 0.45);
}

.login-form-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 24px;
  font-size: 11px;
  color: #94a3b8;
}

@media (max-width: 960px) {
  .login-page {
    padding: 24px 16px;
  }
}
</style>
